module.exports = __webpack_public_path__ + "img/address.c5731a08.png";